import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/analytics'
import firebase from 'firebase/app'

let db

const initializeFirebase = async updateUser => {
  const config = {
    apiKey: process.env['VUE_APP_FIREBASE_API_KEY'],
    authDomain: process.env['VUE_APP_FIREBASE_AUTH_DOMAIN'],
    databaseURL: process.env['VUE_APP_FIREBASE_DATABASE_URL'],
    projectId: process.env['VUE_APP_FIREBASE_PROJECT_ID'],
    storageBucket: process.env['VUE_APP_FIREBASE_STORAGE_BUCKET'],
    messagingSenderId: process.env['VUE_APP_FIREBASE_MESSAGE_SENDER_ID'],
    appId: process.env['VUE_APP_FIREBASE_APP_ID'],
    measurementId: process.env['VUE_APP_FIREBASE_MEASUREMENT_ID']
  }
  firebase.initializeApp(config)
  if (process.env.NODE_ENV === 'production') firebase.analytics()

  db = firebase.firestore()
  if (process.env.VUE_APP_FIREBASE_HOST === 'localhost') {
    db.settings({
      host: 'localhost:8081',
      ssl: false
    })
  }
  db.enablePersistence().catch(err => console.log(err))
  firebase.auth().onAuthStateChanged(updateUser)
}

const getDb = () => db
export {
  initializeFirebase,
  getDb,
  firebase,
  db
}
